import React, { useEffect, useRef, useState, Suspense, lazy } from 'react';
import { componentsMap } from '../dynamic-imports/componentsMap';

const LazyOnVisible = ({ componentKey, children, fallback = null, componentProps = {} }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [DynamicComponent, setDynamicComponent] = useState(null);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
        observer.disconnect();
      }
    });

    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (isVisible && !DynamicComponent && componentKey) {
      const LazyComponent = lazy(componentsMap[componentKey]);
      setDynamicComponent(() => LazyComponent);
    }
  }, [isVisible, componentKey, DynamicComponent]);

  return (
    <div ref={ref}>
      {DynamicComponent ? (
        <Suspense fallback={children?children:fallback}>
          <DynamicComponent {...componentProps} />
        </Suspense>
      ) : null}
    </div>
  );
};

export default LazyOnVisible;